var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFlowsMenuIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2729 4.36364C15.2729 1.95367 17.2266 0 19.6366 0C22.0466 0 24.0002 1.95367 24.0002 4.36364C24.0002 6.77361 22.0466 8.72727 19.6366 8.72727C17.2266 8.72727 15.2729 6.77361 15.2729 4.36364ZM17.4549 4.36364C17.4549 5.56862 18.4318 6.54546 19.6368 6.54546C20.8417 6.54546 21.8186 5.56862 21.8186 4.36364C21.8186 3.15865 20.8417 2.18182 19.6368 2.18182C18.4318 2.18182 17.4549 3.15865 17.4549 4.36364Z",
    fill: "#EBEBF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6364 10.9091C19.0339 10.9091 18.5455 11.3975 18.5455 12V21.8182H2.18182V5.45452H12C12.6025 5.45452 13.0909 4.96611 13.0909 4.36361C13.0909 3.76112 12.6025 3.27271 12 3.27271H1.09091C0.488417 3.27271 0 3.76112 0 4.36361V22.9091C0 23.5116 0.488417 24 1.09091 24H19.6364C20.2389 24 20.7273 23.5116 20.7273 22.9091V12C20.7273 11.3975 20.2389 10.9091 19.6364 10.9091Z",
    fill: "#EBEBF9"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFlowsMenuIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/flowsMenuIcon.01baf1b59ed00ec97e6c676a8ff62e2e.svg";